import React, { useMemo } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { getGameImages } from '../../../../core/helpers/getGameImages';

const FreeBetBackground = observer(() => {
  const { freeSpinBackGround } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container name='FreeBetBackgroundContainer'>
      <Sprite texture={freeSpinBackGround} />
    </Container>
  );
});

export default FreeBetBackground;
